import { gql } from '@apollo/client';

export const FETCH_CHEYCHEY_IMAGE = gql`
 query FetchCheyCheyImage {
    fetchCheyCheyImage {
        data {
            cheycheys {
                id
                image
                type
            }
        }
        error {
            field
            message
            code
        }
    }
}
`;


